package devxertech.com.pages.portfolio.zone

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.toSitePalette
import kotlinx.browser.window
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CommonWebView(image: String, breakpoint: Breakpoint) {
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        modifier = Modifier.fillMaxWidth()
            .padding(topBottom = if (breakpoint <= Breakpoint.MD) 0.px else 0.px)
    ) {
        Box(modifier = Modifier.fillMaxWidth()
            .backgroundColor(sitePalette.modalBackgroundColor.rgb),
            contentAlignment = Alignment.TopCenter
        ) {
            Row(modifier = Modifier.fillMaxWidth()
                .padding(top = if (window.screen.width >= 1600) 50.px else if (breakpoint <= Breakpoint.MD) 0.px else 30.px,
                    bottom = if (window.screen.width >= 1600) 30.px else 0.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                FieldTitleTextNormalSimple(
                    "WEB",
                    color = sitePalette.primary.rgb,
                    fontSize = if (breakpoint <= Breakpoint.MD) 25.px else if (window.screen.width >= 1600) 70.px else 50.px,
                    marginTop = 10.px,
                    fontWeight = 700,
                )
                FieldTitleTextNormalSimple(
                    " VIEW",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontSize = if (breakpoint <= Breakpoint.MD) 25.px else if (window.screen.width >= 1600) 70.px else 50.px,
                    marginTop = 10.px,
                    fontWeight = 700)
            }
            Box(
                modifier = Modifier.fillMaxWidth().padding(top = if (breakpoint < Breakpoint.MD) 60.px
                else if (window.screen.width >= 1600) 233.px else if (breakpoint == Breakpoint.MD) 100.px
                else 150.px,bottom = if (breakpoint < Breakpoint.MD) 35.px else 60.px),
                contentAlignment = Alignment.Center
            ) {
                Image(
                    src = image,
                    modifier = Modifier.width(
                        when {
                            window.screen.width in 768..1200 -> 80.percent
                            window.screen.width > 425 -> 63.percent
                            else -> 90.percent
                        }
                    )
                )
            }
        }
    }
}

